import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLocationSetsUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/geofences_data(/:location_set_id)",
  "/engagement/location_set_data",
];
